import React, {useEffect, useRef} from "react";
import {connect} from 'react-redux';
import Autosuggest from 'react-autosuggest';


import {headerSearchApiRequest,headerSearchChangeApiRequest} from '../actions/header-search';

const getSuggestionValue = suggestion => suggestion.name;

const theme = {
        container:                'form-control auto-height',
        containerOpen:            'react-autosuggest__container--open',
        input:                    'form-control border-0 header-search',
        inputOpen:                'react-autosuggest__input--open',
        inputFocused:             'react-search-focus',
        suggestionsContainer:     'react-autosuggest__suggestions-container',
        suggestionsContainerOpen: 'show-search-result',
        suggestionsList:          'react-autosuggest__suggestions-list',
        suggestion:               'react-autosuggest__suggestion',
        suggestionFirst:          'react-autosuggest__suggestion--first',
        suggestionHighlighted:    'active',
        sectionContainer:         'react-autosuggest__section-container',
        sectionContainerFirst:    'react-autosuggest__section-container--first',
        sectionTitle:             'react-autosuggest__section-title'
      }

class HeaderSearch extends React.Component {
    constructor(props) {
        super(props);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.state = {search:''}
    }


    onChange(event, { newValue })  {
        this.setState({search:newValue});
    }

    onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
        window.location.href = '/'+suggestion.user_type.toLowerCase()+'/'+suggestion.id;
    }

    onSuggestionsFetchRequested (evt) {
        this.setState({search:evt.value});
        this.props.onApiRequest(evt.value);
    }

    onSuggestionsClearRequested () {
        this.props.onApiRequest();
    }

    renderSuggestion(suggestion) {
      return (
        <React.Fragment>
          {suggestion.name}
          <div>
            {suggestion.user_type} <span>{suggestion.mobile_number}</span>
          </div>
        </React.Fragment>
      )
    }

  render() {

    let suggestions = [];
    let inputSearch = '';
    let inputProps = {
      placeholder: 'Search for...',
      value:'',
      onChange: this.onChange
    };

    if(typeof this.props.headerSearch !== 'undefined' && this.props.headerSearch !='') {
        suggestions = this.props.headerSearch.headerSearch;
        inputSearch = this.state.search;
        inputProps.value = inputSearch;
    }

        return (
             <React.Fragment>
                <div className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                    <div className="input-group" >

                        <Autosuggest
                                suggestions={typeof suggestions === 'undefined' ? [] : suggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={inputProps}
                                onSuggestionSelected={this.onSuggestionSelected}
                                theme={theme}
                              />
                        <div className="input-group-append">
                            <button className="btn btn-primary" type="button">
                                <i className="fas fa-search fa-sm"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
  }
}

const mapStateToProps = (state,props) => {
  return {
    headerSearch: state.headerSearch
  }
}
const mapActionsToProps =  {
      onApiRequest : headerSearchApiRequest,
      onChangeApiRequest : headerSearchApiRequest
}
export default connect(mapStateToProps,mapActionsToProps) (HeaderSearch);

